/**
 * Classe que representa o modelo das credenciais específicas do ACS.
 * Esse modelo contém os campos necessários para registrar os dados na base de dados.
 */
export class AcsSpecificalCredentials {
    username: string;
    password: string;
    timeout: number;
}
